import React from 'react';
import Table from 'reactstrap/lib/Table';
import PropTypes from 'prop-types';
import { FormattedTag } from 'core/components';
import { IconTrue } from 'components/icons/icons-vip/icon-true';
import { IconFalse } from 'components/icons/icons-vip/icon-false';

import './vip.scss';

export const VipItemCard = ({ level, sortIndex }) => {
  const {
    birthdayBonus,
    specialBonus,
    vipLevelName,
    vipManager,
    welcomeBonus,
    specialEvents,
    vipTournaments,
    freeBets,
    weeklyCashbacks,
    xp
  } = level;

  return (
    <div className="vip-item-card mr-1_5 d-flex flex-column rounded bg-blue-gradient">
      <div className="d-flex align-items-center justify-content-center m-0_25 rounded-top">
        <img
          src={`/assets/public/images/vip/${sortIndex}.png`}
          className={`vip-img vip-img-${sortIndex}`}
          alt="level"
        />

        <FormattedTag className="h4" id={vipLevelName} />
      </div>

      <div>
        <Table>
          <tbody>
            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.xp"
                scope="row"
                className="text-capitalize text-nowrap font-weight-semi-bold text-left h5 pl-2_25"
              />
              <td className="font-weight-normal pr-4 text-nowrap">{xp}</td>
            </tr>

            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.welcome-bonus"
                scope="row"
                className="text-capitalize font-weight-semi-bold text-left pl-2_25"
              />
              <td className="font-weight-normal pr-4">{welcomeBonus}</td>
            </tr>

            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.birthday-bonus"
                scope="row"
                className="text-capitalize font-weight-semi-bold text-left h5 pl-2_25"
              />
              <td className="font-weight-normal pr-4">{birthdayBonus === 'true' ? <IconTrue /> : <IconFalse />}</td>
            </tr>

            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.weekly-cashbacks"
                scope="row"
                className="text-capitalize font-weight-semi-bold text-left h5 pl-2_25"
              />
              <td className="font-weight-normal pr-4">{weeklyCashbacks === 'true' ? <IconTrue /> : <IconFalse />}</td>
            </tr>

            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.manager"
                scope="row"
                className="text-capitalize font-weight-semi-bold text-left h5 pl-2_25"
              />
              <td className="font-weight-normal pr-4">{vipManager === 'true' ? <IconTrue /> : <IconFalse />}</td>
            </tr>

            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.special-events"
                scope="row"
                className="text-capitalize font-weight-semi-bold text-left h5 pl-2_25"
              />
              <td className="font-weight-normal pr-4">{specialEvents === 'true' ? <IconTrue /> : <IconFalse />}</td>
            </tr>

            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.tournaments"
                scope="row"
                className="text-capitalize font-weight-semi-bold text-left h5 pl-2_25"
              />
              <td className="font-weight-normal pr-4">{vipTournaments === 'true' ? <IconTrue /> : <IconFalse />}</td>
            </tr>

            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.special-bonus"
                scope="row"
                className="text-capitalize font-weight-semi-bold text-left h5 pl-2_25 py-0_25"
              />
              <td className="font-weight-normal pr-4">{specialBonus === 'true' ? <IconTrue /> : <IconFalse />}</td>
            </tr>

            <tr className="border-bottom border-white-10 h5">
              <FormattedTag
                tag="th"
                id="vip.field.free-bets"
                scope="row"
                className="text-capitalize font-weight-semi-bold text-left h5 pl-2_25 py-0_25"
              />
              <td className="font-weight-normal pr-4">{freeBets === 'true' ? <IconTrue /> : <IconFalse />}</td>
            </tr>

          </tbody>
        </Table>
      </div>
    </div>
  );
};

VipItemCard.propTypes = {
  sortIndex: PropTypes.number.isRequired,
  level: PropTypes.shape({
    birthdayBonus: PropTypes.string,
    priorityWithdrawal: PropTypes.string,
    rebate: PropTypes.string,
    rebateAccumulationSpeed: PropTypes.string,
    specialBonus: PropTypes.string,
    specialEvents: PropTypes.string,
    freeBets: PropTypes.string,
    vipLevelName: PropTypes.string,
    vipManager: PropTypes.string,
    vipTournaments: PropTypes.string,
    welcomeBonus: PropTypes.string,
    depositBonus: PropTypes.string,
    weeklyCashbacks: PropTypes.string,
    xp: PropTypes.string
  }),
};

VipItemCard.defaultProps = {
  level: {},
};

